import { Component, EventEmitter, OnDestroy, Output, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { RequestBuilderService } from 'src/app/components/requestbuilder/request-builder.service';
import { SignatureProviderTypeEnum } from 'src/app/constants/signature-provider-type.enum';
import { BuilderActorModel } from 'src/app/models/builder/builder-actor.model';
import { Provider } from 'src/app/models/signatureProvider';

export const EditSignActionModalOptions: NgbModalOptions = {
  backdrop: 'static',
  keyboard: false,
  centered: true,
  size: 'md'
};

@Component({
    templateUrl: './edit-sign-action.modal.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditSignActionModal implements OnDestroy {
  signatureProviders: Provider[] = [];
  selectedSignatureProviders: Provider[] = [];
  disableSignatureProviders: boolean = false;
  private actor!: BuilderActorModel;

  @Output() saveActor: EventEmitter<BuilderActorModel> = new EventEmitter<BuilderActorModel>();

  private signatureProviderSubscription: Subscription | null = null;
  private currentActorSubscription: Subscription | null = null;

  constructor(private activeModal: NgbActiveModal, private requestBuilderService: RequestBuilderService) {
    this.currentActorSubscription = this.requestBuilderService.currentActor$.subscribe((actor: BuilderActorModel) => {
      this.actor = actor;
      this.disableSignatureProviders = this.actor.disableQtsps;

    });
    this.signatureProviderSubscription = this.requestBuilderService.signatureProviders$.subscribe((providers: Provider[]) => {
      this.signatureProviders = providers;
    });
    this.selectedSignatureProviders = [];
    this.actor?.allowedQtsps?.forEach(qtsp => {
      this.selectedSignatureProviders.push(...this.signatureProviders.filter(s => s.id.endsWith(qtsp)));
    });
  }

  ngOnDestroy(): void {
    if (this.currentActorSubscription) {
      this.currentActorSubscription.unsubscribe();
    }
    if (this.signatureProviderSubscription) {
      this.signatureProviderSubscription.unsubscribe();
    }
  }

  public close() {
    this.activeModal.close();
  }

  public save() {
    if (this.actor === null || this.actor === undefined) {
      this.close();
      return;
    }

    if (this.selectedSignatureProviders.length > 0) {
      this.actor!.allowedQtsps = [];
      this.selectedSignatureProviders.forEach(qtsp => {
        this.actor!.allowedQtsps!.push(this.getProviderValue(qtsp))
      });
    }
    this.saveActor.emit(this.actor);
  }

  getProviderValue(qtsp: Provider) {
    return this.requestBuilderService.getProviderValue(qtsp);
  }

  public getSelectedSignatureProviders() {

    return this.selectedSignatureProviders.map(qtsp => qtsp.name).join(', ');
  }

  public applySignatureProvicerSelection(event: any) {
    let isChecked: boolean = (event.srcElement as HTMLInputElement).checked;
    let qtspId: string = (event.target as HTMLInputElement).value;
    if (qtspId.toLocaleLowerCase() === "token") qtspId = SignatureProviderTypeEnum.TokenCertificateSignatureProvider;
    if (isChecked && this.selectedSignatureProviders.findIndex(s => s.id.endsWith(qtspId)) < 0) {
      let qtspIndex = this.signatureProviders.findIndex(s => s.id.endsWith(qtspId));
      this.selectedSignatureProviders.push(this.signatureProviders[qtspIndex]);
    } else {
      let qtspIndex = this.selectedSignatureProviders.findIndex(s => s.id.endsWith(qtspId));
      this.selectedSignatureProviders.splice(qtspIndex, 1);
    }
  }

  public isDisabled(provider: Provider) {
    if (this.actor && this.actor.preferredCscProvider) {
      return provider.id.includes(this.actor?.preferredCscProvider!);
    }
    // THIS IS ONLY MEANT FOR PDFS, AS XBRLS CAN NEVER BE SIGNED BY ESEAL.
    // BUT I PLACE IT HERE TO KEEP THE 2 MODALS THE SAME
    // ESEAL currently has NO provider and stuf set, so when having eseal you get NO preference
    // this basically allows NO/Eseal preference to work as the others
    if (this.actor && !this.actor.preferredCscProvider) {
      return provider.signatureProviderType.startsWith(SignatureProviderTypeEnum.Eseal);
    }
    return false;
  }
  public checkIfProviderIsSelected(provider: Provider) {
    return this.selectedSignatureProviders.includes(provider);
  }
}
